import {handleValidationChange} from '../CommonValidation';

export const validateMenu= (data, packageDetails, setIsError) => {

    var isValid = true;
    var isValidCategories = true;
    var isValidRemarks = true;
    var isValidName = true;
    var isValidItemCode = true;
    var isValidPrinter = true;
    var isValidTo = true;
    var isValidFile = true;
    var isValidPrice = true;
    var isValidDescription = true;
    var isValidPackage = true;
   
    if(data?.is_modifier === "0" && ((!data.categories || data.categories === ""))) {
        handleValidationChange("categories", true, setIsError);
        isValidCategories = false;
    } else {
        handleValidationChange("categories", false, setIsError);
        isValidCategories = true;
    }

    // if(data.remarks === "") {
    //     handleValidationChange("remarks", true, setIsError);
    //     isValidRemarks = false;
    // } else {
    //     handleValidationChange("remarks", false, setIsError);
    //     isValidRemarks = true;
    // }

    if(!data.name || data.name === "") {
        handleValidationChange("name", true, setIsError);
        isValidName = false;
    } else {
        handleValidationChange("name", false, setIsError);
        isValidName = true;
    }

    if(!data.item_code || data.item_code === "") {
        handleValidationChange("item_code", true, setIsError);
        isValidItemCode = false;
    } else {
        handleValidationChange("item_code", false, setIsError);
        isValidItemCode = true;
    }

    if(!data.default_printer || data.default_printer === "") {
        handleValidationChange("default_printer", true, setIsError);
        isValidPrinter = false;
    } else {
        handleValidationChange("default_printer", false, setIsError);
        isValidPrinter = true;
    }

    if(!data.takeout_price || data.takeout_price === "") {
        handleValidationChange("takeout_price", true, setIsError);
        isValidTo = false;
    } else {
        handleValidationChange("takeout_price", false, setIsError);
        isValidTo = true;
    }

    // if(data.file === "") {
    //     handleValidationChange("file", true, setIsError);
    //     isValidFile = false;
    // } else {
    //     handleValidationChange("file", false, setIsError);
    //     isValidFile = true;
    // }

    if (!data.price || data.price === "") {
      handleValidationChange("price", true, setIsError);
      isValidPrice = false;
    } else {
      handleValidationChange("price", false, setIsError);
      isValidPrice = true
    }

    // if (data.description === "") {
    //     handleValidationChange("description", true, setIsError);
    //     isValidDescription = false;
    // } else {
    //     handleValidationChange("description", false, setIsError);
    //     isValidDescription = true
    // }

    if (data.is_package === "1") {
       packageDetails.map((data) => {
        if(data === "") {
            handleValidationChange("is_package", true, setIsError);
            isValidPackage = false
        }
       })
    } else {
        handleValidationChange("is_package", false, setIsError);
        // isValidPackage = true
    }

    isValid = isValidCategories && isValidRemarks && isValidName && isValidFile && 
    isValidPrice && isValidDescription && isValidItemCode && isValidPrinter && isValidTo

    return isValid
  
}